import type { QueryKey } from "@tanstack/react-query";

export const baseQueryKey: QueryKey = ["begenuin"];